import React from "react";
import { Slider } from "./ui/slider";

const LABELS = {
  0: { text: "Calm", tone: "text-teal-700", band: "Mild" },
  1: { text: "Settled", tone: "text-teal-700", band: "Mild" },
  2: { text: "Mostly okay", tone: "text-teal-700", band: "Mild" },
  3: { text: "A bit uneasy", tone: "text-teal-700", band: "Mild" },
  4: { text: "Unsettled", tone: "text-amber-700", band: "Moderate" },
  5: { text: "Struggling", tone: "text-amber-700", band: "Moderate" },
  6: { text: "Distressed", tone: "text-amber-700", band: "Moderate" },
  7: { text: "Very distressed", tone: "text-orange-700", band: "High" },
  8: { text: "Overwhelmed", tone: "text-orange-700", band: "High" },
  9: { text: "Crisis", tone: "text-red-700", band: "Crisis" },
  10: { text: "Unsafe", tone: "text-red-700", band: "Crisis" },
};

export default function DistressSlider({ value, onChange }) {
  const meta = LABELS[value] || LABELS[0];
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-testid="distress-slider-card">
      <div className="flex items-end justify-between mb-2">
        <div>
          <div className="text-sm text-slate-500">How distressed do you feel right now?</div>
          <div className={`font-display text-3xl font-bold mt-1 ${meta.tone}`} data-testid="distress-label">
            {value} · {meta.text}
          </div>
        </div>
        <span className={`text-xs px-3 py-1 rounded-full font-medium ${
          meta.band === "Mild" ? "bg-teal-50 text-teal-800" :
          meta.band === "Moderate" ? "bg-amber-50 text-amber-800" :
          meta.band === "High" ? "bg-orange-50 text-orange-800" :
          "bg-red-50 text-red-800"
        }`} data-testid="distress-band">{meta.band}</span>
      </div>
      <Slider
        data-testid="distress-slider"
        value={[value]}
        min={0}
        max={10}
        step={1}
        onValueChange={(v) => onChange(v[0])}
        className="mt-6"
      />
      <div className="flex justify-between text-xs text-slate-400 mt-2">
        <span>0 · Calm</span>
        <span>5 · Distressed</span>
        <span>10 · Unsafe</span>
      </div>
    </div>
  );
}
